import style from "./warning-card.module.scss";
import type { ReactNode } from "react";

type WarningCardProps = {
  errorMessage?: string;
  dynamicMessage?: string;
  children?: ReactNode;
};

function staticMessageForKey(key?: string): string {
  switch (key) {
    case "errorCPF":
      return "CPF inválido";
    case "errorPhone":
      return "Telefone inválido";
    case "errorEmail":
      return "E-mail inválido";
    case "errorRecoveryEmail":
      return "E-mail de recuperação inválido";
    case "errorPassword":
      return "A senha deve ter 8–16 caracteres, com maiúscula, minúscula, número e um símbolo (# ! @ $ % ^ & *).";
    case "errorName":
      return "Nome inválido";
    case "errorIdentificationNumber":
      return "CPF inválido";
    case "errorPhysicianState":
      return "Estado é obrigatório";
    case "errorPhysicianIdentificationNumber":
      return "CRM é obrigatório";
    case "errorRepeatPassword":
      return "As senhas não coincidem.";
    case "errorMFAcode":
      return "O código deve conter 6 dígitos";
    default:
      return "";
  }
}

function WarningCard({
  errorMessage,
  dynamicMessage,
  children,
}: WarningCardProps) {
  const trimmedDynamic = dynamicMessage?.trim() ?? "";
  const staticMsg = trimmedDynamic ? "" : staticMessageForKey(errorMessage);
  const textChild =
    typeof children === "string" || typeof children === "number"
      ? String(children).trim()
      : "";

  const display =
    trimmedDynamic || staticMsg || textChild || "";

  return (
    <div style={{ color: "#f94646" }} className={style.card}>
      {typeof children !== "string" &&
      typeof children !== "number" &&
      children ? (
        children
      ) : (
        <span>{display}</span>
      )}
    </div>
  );
}

export default WarningCard;
